import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';

const CommonObjectDropdownSelect = ({
  label,
  data,
  onSelect,
  selected,
  disabled = false,
  sx,
  className,
  size = 'medium',
}: {
  label: string;
  selected?: number | string;
  onSelect?: (val: number | string) => void;
  data: {id: number | string; name: string}[];
  disabled?: boolean;
  sx?: SxProps<Theme>;
  className?: string;
  size?: 'small' | 'medium';
}) => {
  const handleChange = (event: SelectChangeEvent) => {
    onSelect?.(event.target.value);
  };

  return (
    <FormControl fullWidth sx={sx} className={className} size={size}>
      <InputLabel id={`${label}-label`}>{label}</InputLabel>
      <Select
        disabled={disabled}
        labelId={`${label}-label`}
        id={`${label}-id`}
        value={selected ? `${selected}` : ''}
        label={label}
        onChange={handleChange}>
        {data.map(o => (
          <MenuItem value={o.id} key={o.id}>
            {o.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default CommonObjectDropdownSelect;
